import React from 'react';
import HeaderSection from "../headerSection/HeaderSection";


 function ReligiousCeremonies() {
  return (
    <div>
            <HeaderSection></HeaderSection>

<p>مراسمات مذهبی</p>
    </div>
  )
}
export default ReligiousCeremonies;